import { useLocation } from "react-router-dom";
import { stripLocaleFromPath } from "./config";

/** Current path without the locale prefix (e.g. `/es/about` → `/about`). */
export const useLocalizedPath = () => {
  const { pathname } = useLocation();
  return stripLocaleFromPath(pathname);
};

export const isActivePath = (currentPathWithoutLocale, path) => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return currentPathWithoutLocale === normalized;
};
